import {Component, OnDestroy, OnInit} from '@angular/core';
import {Subscription} from 'rxjs';
import {OfferListModel, ProjectListModel} from '../../../@models';
import {LocalDataSource} from 'ng2-smart-table';
import {ApiService} from '../../../@core/service/api.service';
import * as saveAs from 'file-saver';

@Component({
  selector: 'ngx-offer-list',
  templateUrl: './offer-list.component.html',
  styleUrls: ['./offer-list.component.scss'],
})
export class OfferListComponent implements OnInit, OnDestroy {

  settings = {
    actions: false,
    columns: {
      sales: {
        title: 'Sales',
        width: '10rem',
      },
      customer: {
        title: 'Customer',
        width: '10rem',
      },
      city: {
        title: 'City',
        width: '7.5rem',
      },
      country: {
        title: 'Country',
        width: '7.5rem',
      },
      region: {
        title: 'Region',
        width: '10rem',
      },
      businessUnit: {
        title: 'BU',
        width: '10rem',
      },
      name: {
        title: 'Project',
        width: '10rem',
      },
      material: {
        title: 'Equipment',
        width: '7.5rem',
      },
      offerDate: {
        title: 'Offer date',
        width: '5rem',
      },
      offerTitle: {
        title: 'Offer title',
        width: '10rem',
      },
      status: {
        title: 'Status',
        width: '5rem',
      },
      text: {
        title: 'Text',
        width: '10rem',
      },
    },
    filter: {
      inputClass: 'filter',
    },
  };

  private subscription: Subscription;

  projects: OfferListModel[];

  source: LocalDataSource;

  constructor(private api: ApiService) { }

  ngOnInit() {
    this.source = new LocalDataSource();

    this.subscription = this.api.offerList().subscribe(values => {
      this.projects = values; // .filter(x => x.lastActivity != null && x.lastActivity.length > 0);
      /* this.projects.forEach(x => {
        x.probability = isNaN(x.probability as number) ? '' : `${x.probability as number * 100} %`;
        x.share = isNaN(x.share as number) ? '' : `${x.share as number * 100} %`;
        x.equipmentValue = (x.equipmentValue || '').toLocaleString('en-US');
      });*/
      this.source.load(this.projects);
    });
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  downloadXlsx() {
    this.api.downloadOfferXlsx().subscribe(data => {
      saveAs(data, 'OfferList.xlsx');
    });
  }
}
